import React, { useState, useEffect, useRef } from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { subscribe } from 'react-contextual';

import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  getStagesPermissions,
  listProjectSubstagesSchedule,
} from '../../redux/actions/table/stages';
import {
  __,
  getActiveStage,
  redirect,
  setActiveProject,
  setTableParams,
} from '../../core/utils';
import {
  enableProjectsDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import styles from '../../styles/views/stages/Stages.scss';

// THE BASE TABLE IMPORTS //
import ProjectPlanningTable from './ProjectPlanningTable';
import { withRouter } from 'react-router';
import Localization from '../../helpers/Localization';
import { readProjectGeneral } from '../../redux/actions/projects';
import TitleBar from '../../containers/TitleBar';

const Stages = ({
  actions,
  table,
  match,
  localization,
  auth,
  main_language,
}) => {
  const [expandedRows, setExpandedRows] = useState(null);
  const [focusedId, setFocusedId] = useState([]);
  const [isProjectAdministrator, setIsProjectAdministrator] = useState(false);

  useEffect(() => {
    setActiveProject(match.params.project);

    getStagesPermissions(match.params.project).then(({ response }) => {
      const is_project_administrator = _.get(response.data, 'administrator');
      const canViewProjectPlanning = _.includes(
        _.get(response.data, 'planning_module_visibility.permissions', []),
        'planning_module_visibility'
      );

      createSidebar({
        title: __('submenu.title.project'),
        items: _.compact([
          {
            title: __('submenu.title.stages'),
            link: () => '/projects/' + match.params.project + '/stages',
            active: true,
          },
          {
            title: __('submenu.title.teams'),
            link: () => '/stages/' + getActiveStage() + '/teams',
          },
          {
            title: __('submenu.title.approvers'),
            link: () => '/stages/' + getActiveStage() + '/approvers',
          },
          {
            title: __('submenu.title.project-properties'),
            link: () => '/projects/' + match.params.project + '/general',
          },
          {
            title: __('submenu.title.import_spreadsheet'),
            link: () => '/import/' + getActiveStage(),
          },
          canViewProjectPlanning && {
            title: __('submenu.title.project-planning'),
            link: () => '/projects/' + match.params.project + '/project-planning',
          },
        ]),
      });

      setIsProjectAdministrator(is_project_administrator);
      listProjectSubstagesSchedule(match.params.project);
    });
  }, [match.params.project]);

  useEffect(() => {
    if (expandedRows !== null || _.isEmpty(table?.substages)) {
      return;
    }

    const defaultExpanded = _.reduce(
      table.substages,
      (ids, group) => {
        !_.isEmpty(group.children) && ids.push(group.id);
        return ids;
      },
      []
    );

    setExpandedRows(defaultExpanded);
  }, [expandedRows, table?.substages]);

  useEffect(() => {
    setActiveProject(match.params.project);

    enableProjectsDropdown(({ project_id }) =>
      redirect('/projects/' + project_id + '/stages')
    );

    readProjectGeneral(match.params.project).then(({ response }) => {

      setTableParams('project_planning', {
        main_language: response.data.main_language, // project language
        project_id: match.params.project,
      });

      listActiveModules();
    });

  }, [match.params.project]);

  const language_id = auth.language_id; // app language

  const main_lanugage = main_language; // project language

  return (
    <div className={styles.table}>
      <TitleBar
        title={__('submenu.title.stages')}
        dropdownHeader={__('submenu.title.project')}
        toolbar
      />

      <div className={styles.tableContent}>
        <ProjectPlanningTable
          name='stages'
          title={__('submenu.title.stages')}
          expandedRows={expandedRows}
          localization={localization}
          data={table?.substages}
          listProjectSubstages={() => {
            listProjectSubstagesSchedule(match.params.project);
          }}
          onExpandedRowsChange={(expanded_rows) => {
            setExpandedRows(expanded_rows);
          }}
          isProjectAdministrator={isProjectAdministrator}
          onFocusChange={setFocusedId}
          focusedId={focusedId}
          languageId={main_lanugage}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    table: state.table['project_planning'],
    main_language: state.table['project_planning'].main_language,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.project_planning/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(Stages))
);

// componentDidUpdate(prevProps) {
//   if (
//     this.props.table.clicked_row &&
//     this.props.table.clicked_row !== prevProps.table.clicked_row
//   ) {
//     if (!prevProps.table.clicked_row) {
//       this.props.actions.setTableParams({
//         flyout: undefined,
//       });
//     }

//     readStage(this.props.table.clicked_row);
//   }
// }

// @autobind
// _setStageStatus(e, stage_id, status) {
//   e.stopPropagation();

//   updateStageStatus(stage_id, status).then(() => {
//     listProjectStages(this.props.match.params.project);

//     setNotification(__('project.stages.notification.success-update'));

//     hideDropdown();
//   });
// }

// @autobind
// _handleSubmit(formData) {
//   return validateForm(
//     updateStage(formData.id, _.omit(formData, ['id'])).then(() => {
//       listProjectStages(this.props.match.params.project);

//       readStage(getURLParam('id')).then(({ response }) => {
//         const data = _.transform(
//           response.data,
//           (data, value, key) => {
//             data[key] = _.has(value, 'date')
//               ? moment(value).format('YYYY-MM-DD')
//               : value;
//           },
//           {}
//         );

//         this.setState({ preview: data });
//       });

//       listActiveModules();

//       setNotification(__('project.stages.notification.saved'));
//     })
//   );
// }

// const singleActions = (stage) => [
//   // <Tooltip text={__('projects.tooltips.stages.make-current')} key={_.uniqueId()}><MakeCurrentStageIcon
//   //     onClick={e => {
//   //         e.stopPropagation();
//   //
//   //         updateStageCurrent(stage).then(() => {
//   //             listProjectStages(this.props.match.params.project);
//   //
//   //             setNotification(__("project.stages.notification.current-successfully-set"));
//   //
//   //             this.props.actions.setTableParams({
//   //                 actioned_row: undefined
//   //             });
//   //         });
//   //     }}
//   // /></Tooltip>,
//   <Tooltip text={__('projects.tooltips.stages.move-up')} key={_.uniqueId()}>
//     <MoveRowUpIcon
//       onClick={(e) => {
//         e.stopPropagation();

//         updateStageOrder(stage, 'up').then(() => {
//           listProjectStages(this.props.match.params.project);

//           setNotification(
//             __('project.stages.notification.order-successfully-set')
//           );

//           this.props.actions.setTableParams({
//             actioned_row: undefined,
//           });

//           listActiveModules();
//         });
//       }}
//     />
//   </Tooltip>,
//   <Tooltip
//     text={__('projects.tooltips.stages.move-down')}
//     key={_.uniqueId()}
//   >
//     <MoveRowDownIcon
//       onClick={(e) => {
//         e.stopPropagation();

//         updateStageOrder(stage, 'down').then(() => {
//           listProjectStages(this.props.match.params.project);

//           setNotification(
//             __('project.stages.notification.order-successfully-set')
//           );

//           this.props.actions.setTableParams({
//             actioned_row: undefined,
//           });

//           listActiveModules();
//         });
//       }}
//     />
//   </Tooltip>,
// ];

// const stage_statuses = [
//   {
//     value: 1,
//     label: __('project-settings.stages.flyout.status.not-started'),
//   },
//   {
//     value: 2,
//     label: __('project-settings.stages.flyout.status.started'),
//   },
//   {
//     value: 3,
//     label: __('project-settings.stages.flyout.status.finished'),
//   },
// ];

// const preview = (
//   <StagesFlyout
//     data={this.props.table.flyout}
//     is_project_administrator={this.state.is_project_administrator}
//     readAction={(stage_id) => {
//       return new Promise(() => {
//         readStage(getURLParam('id') || stage_id);
//       });
//     }}
//   />
// );

// return (
//   <Table
//     listAction={() => listProjectStages(this.props.match.params.project)}
//     name='stages'
//     title={__('submenu.title.stages')}
//     singleActions={this.state.is_project_administrator && singleActions}
//     columns={columns}
//     preview={this.props.table.flyout ? preview : []}
//     onLoad={() => listActiveModules()}
//   />
// );
